import React, { useState } from 'react';
import { useTheme } from '@mui/material/styles';
import { PaletteMode, useMediaQuery } from '@mui/material';
import { LG_WIDTH, MD_WIDTH, SM_WIDTH } from '@eposnow/ui-core';

export const getColorMode = (): PaletteMode =>
  (sessionStorage.getItem('colorMode') as PaletteMode) || ('light' as PaletteMode);

export const getAnimationsDisabled = (): boolean =>
  sessionStorage.getItem('animationsDisabled') === 'true';

const UIContext = React.createContext({
  isMobile: false,
  isSmallDevice: false,
  isTablet: false,
  isMediumDevice: true,
  isLargeDevice: false,
  noStepsDevice: false,
  iOS: false,
  colorMode: 'light' as PaletteMode,
  setColorModeFromBoolean: (_newColorMode: boolean) => {
    /* void */
  },
  animationsDisabled: false,
  setAnimationsDisabledFromBoolean: (_newDisableAnimation: boolean) => {
    /* void */
  },
});

const UIContextProvider = ({ children }: { children: JSX.Element }) => {
  const iOS = typeof navigator !== 'undefined' && /iPad|iPhone|iPod/.test(navigator.userAgent);
  const dimensionsTheme = useTheme();
  const isSmallDevice = useMediaQuery(dimensionsTheme.breakpoints.down(360));
  const isMobile = useMediaQuery(dimensionsTheme.breakpoints.down(SM_WIDTH));
  const isTablet = useMediaQuery(dimensionsTheme.breakpoints.between(SM_WIDTH, MD_WIDTH));
  const isMediumDevice = useMediaQuery(dimensionsTheme.breakpoints.up(MD_WIDTH));
  const isLargeDevice = useMediaQuery(dimensionsTheme.breakpoints.up(LG_WIDTH));
  const noStepsDevice = useMediaQuery(dimensionsTheme.breakpoints.down(700));

  const [animationsDisabled, setAnimationsDisabled] = useState(getAnimationsDisabled());
  const [colorMode, setColorMode] = useState<PaletteMode>(getColorMode());

  const setColorModeFromBoolean = (isDarkTheme: boolean) => {
    const newColorMode = isDarkTheme ? 'dark' : 'light';
    sessionStorage.setItem('colorMode', newColorMode);
    setColorMode(newColorMode);
  };

  const setAnimationsDisabledFromBoolean = (isAnimationsDisabled: boolean) => {
    sessionStorage.setItem('animationsDisabled', JSON.stringify(isAnimationsDisabled));
    setAnimationsDisabled(isAnimationsDisabled);
  };

  const contextValue = {
    isMobile,
    isSmallDevice,
    isTablet,
    isMediumDevice,
    isLargeDevice,
    iOS,
    colorMode,
    setColorModeFromBoolean,
    animationsDisabled,
    setAnimationsDisabledFromBoolean,
    noStepsDevice,
  };
  return <UIContext.Provider value={contextValue}>{children}</UIContext.Provider>;
};

export { UIContext, UIContextProvider };
